import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';

@Component({
  selector: 'app-simple-table',
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.scss'],
})
export class SimpleTableComponent implements OnInit {
  [x: string]: any;
  checked = false;
  visible = true;
  indeterminate = true;
  needDelete = false;
  needEdit = true;
  needCheck = true;
  @Input() dbName = '';
  @Input() listOfData = [];
  @Input() formItems: FormData[] | undefined;
  @Input() nzScroll = {};
  @Output() editRow = new EventEmitter();
  @Input() setOfCheckedId: Set<number> | undefined;
  @Output() setOfCheckedIdChange = new EventEmitter<Set<number>>();

  ngOnInit(): void {
    // do something
  }
  onItemChecked(id: number, checkedStatus: boolean): void {
    this.updateCheckedSet(id, checkedStatus);
    if (this.setOfCheckedId?.size) {
      this.checked =
        this.setOfCheckedId?.size === this.listOfData.length ? true : false;
      this.indeterminate = !this.checked;
    } else {
      this.indeterminate = false;
      this.checked = false;
    }
  }
  onAllChecked(checked: boolean): void {
    this.indeterminate = false;
    this.checked = checked;
    this.listOfData.forEach((item) => {
      this.updateCheckedSet(item.id, this.checked);
    });
  }
  updateCheckedSet(id: number, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(id);
    } else {
      this.setOfCheckedId.delete(id);
    }
  }
}
